import { atomWithReset } from 'jotai/utils'

import { type CustomerAttributeGroup } from '~/hooks/useSurveyQuery'

type DialogInfo =
  | {
      dialogType: 'create'
      customerAttributeGroup?: null
    }
  | {
      dialogType: 'delete' | 'update'
      customerAttributeGroup: CustomerAttributeGroup
    }
  | {
      dialogType: 'sort'
      customerAttributeGroup?: null
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | null>(null)
